'use strict';


import minicart from '../../minicart';
import page from '../../page';
import util from '../../util';
import samples from '../../samples';
import analytics from '../../analytics';
import currentLayout from '../../detect-layout';
import analyticsEmea from '../../analyticsBase';
import cart from '../../pages/cart';
import _ from 'lodash-es';

const currLayoutVal = currentLayout.init();

/**
 * @description set addToCart error message
 * @param {String} msg
 */
var timer;
var setAddToCartError = function (msg, $form) {
	let $errEle = $form.find("#a2c-error");
	let $errEleSticky = $form.find("#a2c-error-sticky");
	let $quickviewError = $form.closest('.product-content').find('.add-to-cart-sticky #a2c-error-quickview');
	const isQuickShopOpen = $('#quick-shop-panel').hasClass('opened');
	if (isQuickShopOpen) {
		$quickviewError.addClass('active');
		$errEle = $quickviewError;
	}

	$errEle.html(msg).slideDown('fast', function () {
		setTimeout(function () {
			$errEle.slideUp(500, function () {
				$(this).removeClass('active');
			});
		}, 2000);
	});

	$errEleSticky.html(msg).slideDown('fast', function () {
		setTimeout(function () {
			$errEleSticky.slideUp(500);
		}, 2000);
	});
};

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form) {
	var $form = $(form);

	return Promise.resolve($.ajax({
		type: 'POST',
		url: util.ajaxUrl(Urls.addProduct),
		data: $form.serialize()
	})).then(function (response) {
		// handle error in the response
		if (response.error) {
			setAddToCartError(response.error, $form);
			throw new Error(response.error);
			return false;
		}

		return response;
	});
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e) {
	e.preventDefault();
	var isMobile = util.isMobile();
	var $form = $(this).closest('form');
	var isCart;
	addItemToCart($form).then(function (response) {
		var $uuid = $form.find('input[name="uuid"]');
		if ($uuid.length > 0 && $uuid.val().length > 0) {
			page.refresh();
		} else if ($('.cart_page').length > 0) {
			cart.init();
			$.ajax({
				type: 'GET',
				url: util.ajaxUrl(Urls.cartShow, 'format', 'ajax'),
				success: function (response) {
					$('#primary').html(response);
					cart.init();
					$('.minicart-link .bag-icon').html('<span class="cart-count">' + $('.cart-item-quantity').html()  + '</span>');
					$('html').removeClass('filter-open modal-open');
					$('.quick-shop-panel .icon-close').click();
					analyticsEmea.quickviewCartAdd();
				},
				error: function () {
					page.refresh();
				}
			});
		} 
		else {
			// do not close quickview if adding individual item that is part of product set
			// @TODO should notify the user some other way that the add action has completed successfully

			$('.stick-buy-container').removeClass('open');
			$('.sticky-buy-link').removeClass('active');
			$(document).trigger("gtadd-to-cart");

			// show minicart slide panel only in mobile view
			minicart.show(response, true); // true parameter enables minicart's slide right animation
			
			openMinicartSlidPanel();
		}
	}.bind(this));
};


/**
 * @description Handler to handle the add all to cart event
 */
function addAllToCart(pids, to) {
	var isMobile = util.isMobile();
	if (!pids || pids.length === 0) {
		return;
	}
	var urlName = Urls.addMultipleProducts;	

	$.post(util.appendParamsToUrl(urlName, {
		format: 'ajax',
		pid: pids
	}), function (data) {		

		$('.stick-buy-container').removeClass('open');
		$('.sticky-buy-link').removeClass('active');

		minicart.show(data, true); // true parameter enables minicart's slide right animation
		openMinicartSlidPanel();
	});
};


function openMinicartSlidPanel(){
	var $minicart = $("#minicart"),
		$quickshop = $(".quick-shop-panel");
	// early exit
	if(!$minicart.length) { return; }
		
	// close quickshop panel
	if($quickshop.length && $quickshop.hasClass('opened')) {
		$('.quick-shop-panel .icon-close').click();
	}

	// added flag to open mini-cart 
	$minicart.addClass("opened").removeClass('closed');
	$minicart.removeAttr('style');
	minicart.crosssellRecommendationModal();
	if($('.nav-redesign').length  && $(window).width() < 991) {
		$('.logo-shiseido .header-logo-default').hide();
	}
	// to reinit custom scrollbox lib	
	if ($minicart.hasClass('opened')){
		reinitMinicartScrollbox();
		// push event to datalayer when minicart opened (only mobile)
		if(currLayoutVal === 'mobile') {
			analyticsEmea.minicartPanelOpened();
		}
    }
	analyticsEmea.quickviewCartAdd();
	analyticsEmea.cartModalOpen();
	localStorage.setItem("cartModalOpen", "miniCartOpen");
}

//to re-initialize scrollbar when minicart item updated
function reinitMinicartScrollbox() {
	setTimeout(function(){
		if ($('.minicart-link .sb-container .sb-content').length === 0) {
			$('.sb-container').scrollBox();
		} else {
			if ($(window).width() < 991) {
				$('.minicart-link .sb-container .sb-content').removeAttr('style');
				$(window).trigger('resize.scrollBox');
			}
		}
	}, 300);
}

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllTo = function (e) {
	e.preventDefault();

	var pidData = $('#pids').val();
	
	//Product set
	if($('.product-set-list').length > 0){
		var pidData = getPSPidData();
		addAllToCart(pidData, e.data.to);
		return;
	}		

	minicart.addAllProducts(pidData, e.data.to);
};

//form Product Set PID data
function getPSPidData(){
	var pid = '',
	data='',
	qty = $('#quantity').val();
	
	$('.product-set-list  .product-set-item').each(function(){
		//avail
		pid = $(this).find("input[name=pid]").val();
		data = data != '' ? data+','+pid+':'+qty : pid+':'+qty
		
	});
		
	return data;
}


// Accepts jQuery selector of n elements containing data attr storing pid
// Returns formatted pid data required for addAllProducts request (ex. 'pidA:1,pidB:1,pidN:1')
// To fetch qty, searches for qty dropdown or defaults to 1
function formatPidDataFromEles($selector) {
	return $selector.toArray().map(function (ele) {
		var $ele = $(ele),
			pid = $ele.data('pid'),
			qty = $ele.find('select[name="Quantity"]').length ? $ele.find('select[name="Quantity"]').val() : 1;

		return pid + ":" + qty;
	}).join(',');
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
export default function () {
	$('.add-to-cart[disabled]').attr('title', $('.availability-msg').text());
	$('#add-all-to-cart').on('click', {
		to: 'Cart'
	}, addAllTo);
	
	$('.stick-buy-container .add-all-to-cart').on('click', {
		to: 'Cart'
	}, addAllTo);
	
	$('.product-form-actions .product-set-wishlist').on('click', {
		to: 'Wishlist'
	}, addAllTo);
};

/**
 * duplicated add-to-cart from export above - endorse for re-factoring
 * reason for duplication : sometimes add to bag/cart script won't trigger/execute
 */
$(document).on('click', '.product-detail .add-to-cart', addToCart);
$(document).on('click', '.stick-buy-container .add-to-cart', addToCart);
$(document).on('click', 'button.sample-bonus-add-to-cart', addSamplesToCart);
$(document).on('click', '.bonus-sample-selection .product-tile-wrapper', sampleTileSelect);
$(document).on('click', '.reveal.sample-selection .close-button', function (e) {
	scrollToTop(e);
});
$("form.multi-select-form").on('submit', function (e) {
	e.preventDefault();

	var pidData = formatPidDataFromEles($(this).find('button.multiselect[value="selected"]'));
	minicart.addAllProducts(pidData, 'Cart');
});

function sampleTileSelect(e) {
    e.preventDefault();

    const $this = $(this);

    // Early exit for minicart promotion content
    if ($this.closest('.minicart-promotion-content').length) {
        return;
    }

    const $btn = $this.find('button.multiselect');
    const $multiSelectForm = $this.closest('form');
    const $thresholdInput = $multiSelectForm.find('input#pids');
    const $samplesBonusError = $('#samples-bonus-error');
    const $productTileWrapper = $this.closest('.product-tile-wrapper');
    const btnIsSelected = $btn.val() === 'selected';
    const $bonusContentWrapper = $('.bonus-content-wrapper').find('.bonus-footer');
	const isCartPage = $('.cart_page').length > 0;
    const isBonusRedesign = $('.bonus-redesign').length > 0;
    const $bonusSampleSelection = $('.bonus-sample-selection');
    const $sampleBonusCount = $('span.sample-bonus-count');
    const $modalBody = $('.modal-body');
    const $promoTileWrapper = $('.product-tile-selected');
    const $sampleContentWrapper = $this.closest('.sample-content-wrapper');
    const limitCount = $sampleContentWrapper.length ? SitePreferences.SAMPLES_PER_ORDER_COUNT : window.Constants.MAX_BONUS_ITEMS;
	const selectedCount = $multiSelectForm.find('button[value="selected"]').length;
	
    // Clear error message
    if ($samplesBonusError.length) {
        $samplesBonusError.html('');
    }

    if (limitCount === 1) {
        if (!$this.hasClass('product-tile-selected')) {
			$('button.multiselect').removeClass('icon-checkmark').addClass('icon-plus-with-round-border');
            $promoTileWrapper.removeClass('product-tile-selected');
            $productTileWrapper.addClass('product-tile-selected');
			$productTileWrapper.find('button.multiselect').addClass('icon-checkmark').removeClass('icon-plus-with-round-border');
            $bonusContentWrapper.removeClass('disabled');
            $bonusContentWrapper.find('.add-to-cart').prop('disabled', false);
            $thresholdInput.val($this.find('.add-to-cart').data('pid'));
        } else {
            $promoTileWrapper.removeClass('product-tile-selected');
            $bonusContentWrapper.addClass('disabled');
			$productTileWrapper.find('button.multiselect').removeClass('icon-checkmark').addClass('icon-plus-with-round-border');
            $bonusContentWrapper.find('.add-to-cart').prop('disabled', true);
            $thresholdInput.val('');
        }
    } else {
        if (btnIsSelected || selectedCount < limitCount) {
            // Toggle button state
            $btn.toggleClass('remove');
            $btn.val(btnIsSelected ? 'selectable' : 'selected');

            if (isCartPage || isBonusRedesign) {
                $bonusSampleSelection.addClass('bonus-sample-selection-redesign');
                if (btnIsSelected) {
                    $btn.removeClass('icon-checkmark').addClass('icon-plus-with-round-border');
                    $productTileWrapper.removeClass('product-tile-selected');
                } else {
                    $btn.addClass('icon-checkmark').removeClass('icon-plus-with-round-border');
                    $productTileWrapper.addClass('product-tile-selected');
                }
            } else {
                $btn.html(btnIsSelected ? $btn.data('select') : $btn.data('selected'));
            }
        } else if ($samplesBonusError.length) {
            // Cap reached, report error
            $samplesBonusError.html($("input#pids").data('error'));
            $modalBody.animate({ scrollTop: 0 }, 200);
        }

        // Build selected product list
        const selectedProductList = $multiSelectForm.find('button[value="selected"]').map(function () {
            return $(this).data('pid');
        }).get();

        // Store all selected products to hidden input
        $thresholdInput.val(selectedProductList.join(','));

        // Enable or disable "Add to Bag" button
        const cartButton = $thresholdInput.data('button');
        if (selectedProductList.length > 0) {
            $('button.' + cartButton).removeAttr('disabled');
        } else {
            $('button.' + cartButton).attr('disabled', 'true');
        }

        // Update selected counter
        const selectedLimit = parseInt(limitCount, 10);
        const displayCount = Math.min(selectedProductList.length, selectedLimit);
        if ($('body').hasClass('cart_page')) {
            $sampleBonusCount.html(' ' + displayCount + '/' + $sampleBonusCount.data('samplesperorder'));
        } else {
            $sampleBonusCount.html(' [' + displayCount + ']');
        }
    }
}

function addSamplesToCart(e) {
	e.preventDefault();

	const $this = $(this);
	let url = util.toAbsoluteUrl($this.data('action')),
		isMobile = util.isMobile();
	const isBonus = $this.closest('#bonus-add-to-cart').length;
	const redesignurl= $('.add-cart-hidden-field').data('redesignurl');
	const $minicartPromotionContent = $this.parents('.minicart-promotion-content');

	if(redesignurl) {
		if(isBonus) {
			if($(".pt_cart").length) {
				url = url+'&actionSrc=bonus'+'&isRenderForm=true'+'&pageSrc=cart';
			} else {
				url = url+'&actionSrc=bonus'+'&isRenderForm=true'+'&pageSrc=minicart';
			}
		}
	}
	$this.prop('disabled', true);
	if($minicartPromotionContent.length){
		$minicartPromotionContent.find('.add-btn-container').addClass('disabled');
	} else {
		$('.sample-selection .ajax-loader').show();
	}

	const prdPids = $(this).parents('form').find("input#pids").val();

	$.ajax({
		url: url,
		data: {
			pid: $(this).parents('form').find("input#pids").val()
		},
		method: 'POST'
	}).done(function (response) {
		if ($('.sample-bonus-add-to-cart').data('redirect')) {
			if ($(".pt_cart").length) {
				if (redesignurl) {
					if(isBonus) {
						$('#bonus-sample-selection .modal-close').trigger('click');
						if ($('.overlay').length == 0) {
							$('body').append('<div class="overlay"></div>')
							$('.overlay').css('display', 'block');
						}
						setTimeout(() => {
							$('#primary').html(response);
							cart.init();
							analytics.addBonusProductDataLayer(prdPids);
							$('.overlay').remove();
						}, 200);
					} else {
						page.refresh();
					}

				}else{
					$('#bonus-sample-selection .modal-close').trigger('click');
					window.location.assign(Urls.cartShow);
				}
			} else {
				minicart.show(response, true);	// to show minicart slide panel 
				// append "opened" class to "minicart-link" which keeps minicart panel opened
				$("#minicart").closest('.minicart-link').addClass('opened');
				$('#bonus-sample-selection .modal-close').trigger('click');
				$('html').addClass('modal-open');

				util.debounce(function () {
					$('html').removeClass('filter-open');
					if($minicartPromotionContent.length){
						analyticsEmea.addBonusProductMinicartDataLayer(prdPids);
					} else {
						analytics.addBonusProductDataLayer(prdPids);
					}
					
				}, 5000)();
				
				minicart.init();
			}
			
		} else {
			var $div = $('<div>').html(response);
			if ($div.find('.add-cart-confirmation-product').length && !isMobile) {
				minicart.show(response, true);
				
			}
			if ($('.sample-bonus-add-to-cart').length) {
				$('#bonus-sample-selection .modal-close').trigger('click');
			}
		}
		$('.sample-selection .ajax-loader').hide();
	});
}